import { functions } from '@upflowy/firestore';
import { CreateEventType } from '@upflowy/types';
import { httpsCallable } from 'firebase/functions';

import { withOfflineExceptionAsync } from '../helpers/with-offline-exception';

type CreateEventResponse = {
  data: {
    success: boolean;
    message: string;
    error: Error | null;
    trace?: {
      respondedAt: number;
      responseStatus: number;
      response: string;
      errors: Record<string, unknown>;
    };
  };
};

export const sendEvent: (input: CreateEventType) => Promise<CreateEventResponse> = httpsCallable(
  functions,
  'bigQueryEventCreate',
);

type FlowConfigResponse = {
  data: {
    showWatermark: boolean;
  };
};

export const getFlowConfig = withOfflineExceptionAsync<
  (input: { flowId: string; idToken: string }) => Promise<FlowConfigResponse>
>(httpsCallable(functions, 'getFlowConfig'));

type LocationResponse = {
  data: {
    country?: string | null;
    city?: string | null;
    region?: string | null;
    ipAddress?: string | null;
  };
};

export const getLocation = withOfflineExceptionAsync<() => Promise<LocationResponse>>(
  httpsCallable(functions, 'getLocation'),
);
